
export const collections = [
  {
    id: 1,
    name: 'Lumière',
    description: 'Inspired by the play of light and shadow, capturing moments of brilliance',
    image: 'https://public.readdy.ai/ai/img_res/ff2ad452f0536dc2eada41dc9a3fca2a.jpg'
  },
  {
    id: 2,
    name: 'Essence',
    description: 'Pure forms that celebrate the beauty of simplicity and restraint',
    image: 'https://readdy.ai/api/search-image?query=elegant%20pearl%20drop%20earrings%20with%20rose%20gold%20settings%20hanging%20on%20transparent%20acrylic%20display%20stand%20soft%20cream%20beige%20background%20natural%20window%20light%20creating%20gentle%20glow%20luxury%20fine%20jewelry%20product%20photography%20sophisticated%20minimalist%20aesthetic%20clean%20composition%20high%20end%20brand%20visual&width=600&height=800&seq=essence002luxpearl&orientation=portrait'
  },
  {
    id: 3,
    name: 'Éternité',
    description: 'Timeless designs that transcend fleeting trends and seasons',
    image: 'https://readdy.ai/api/search-image?query=luxurious%20tennis%20bracelet%20with%20brilliant%20cut%20diamonds%20in%20white%20gold%20setting%20displayed%20on%20soft%20ivory%20velvet%20cushion%20bright%20natural%20daylight%20photography%20creating%20maximum%20sparkle%20sophisticated%20aesthetic%20clean%20composition%20luxury%20fine%20jewelry%20product%20shot%20high%20end%20brand%20visual&width=600&height=800&seq=eternite002luxbracelet&orientation=portrait'
  },
  {
    id: 4,
    name: 'Soleil',
    description: 'Radiant pieces that capture the warmth and energy of golden sunlight',
    image: 'https://readdy.ai/api/search-image?query=exquisite%20yellow%20gold%20statement%20necklace%20with%20intricate%20chain%20design%20and%20gemstone%20pendant%20displayed%20on%20warm%20champagne%20silk%20fabric%20soft%20natural%20daylight%20photography%20sophisticated%20aesthetic%20clean%20composition%20luxury%20fine%20jewelry%20product%20shot%20neutral%20elegant%20tones%20gentle%20shadows%20high%20end%20brand%20visual&width=600&height=800&seq=soleil002luxstatement&orientation=portrait'
  }
];
